import { render, staticRenderFns } from "./AdminFaqList.vue?vue&type=template&id=e23b8e0e"
import script from "./AdminFaqList.vue?vue&type=script&lang=js"
export * from "./AdminFaqList.vue?vue&type=script&lang=js"
import style0 from "./AdminFaqList.vue?vue&type=style&index=0&id=e23b8e0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports